import route from '@/router/index'
// import {authLogout} from '../security/index'
import Stomp from 'webstomp-client'
import { ACCESS_TOKEN_NAME, EXP_TOKEN } from '../constant'

const socket = (function () {
  let isConnected
  let connection
  let stompClient

  let connect = function (successCallback, errorCallback) {
    let accessToken = localStorage.getItem(ACCESS_TOKEN_NAME);
    let expTime = localStorage.getItem(EXP_TOKEN);
    var dateExpTime = new Date(expTime*1);
    var currentTime = new Date();
    if (accessToken && currentTime <= dateExpTime) {
      connection = new WebSocket(process.env.SOCKET_ADDRESS+'/mhdt?access_token=' + accessToken)
      stompClient = Stomp.over(connection)

      /* Disable console */
      stompClient.debug = function () {
        return '';
      }
      stompClient.connect(
        {},
        () => {
          isConnected = true
          stompClient.subscribe('/errors', function () {
            isConnected = false
          })
          successCallback(stompClient);
        },
        error => {
          isConnected = false
          errorCallback(error)
        }
      )
    }
    connection.onclose = function (e) {
      isConnected = false;
      setTimeout(function () {
        connect(successCallback, errorCallback);
      }, 5000);
    };

    connection.onerror = function (err) {
      isConnected = false;
      connection.close();
    };
  }

  let sendMessage = function (path, data) {
    if (stompClient && stompClient.connected) {
      stompClient.send(path, data, {})
    }
  }

  let disconnect = function () {
    if (stompClient && stompClient.connected) {
      stompClient.disconnect()
    }
  }

  let hasConnected = function () {
    return isConnected
  }

  let init = function () {
  }

  init()

  return {
    isConnected: hasConnected,
    disconnect: disconnect,
    sendMessage: sendMessage,
    connect: connect,
  }
})(route)

export function checkConnect() {
  return socket.isConnected()
}

export function connect(successCallback, errorCallback) {
  return socket.connect(successCallback, errorCallback)
}

export function disConnectSocket() {
  return socket.disconnect()
}

export function sendMessageSocket(path, data) {
  return socket.sendMessage(path, data)
}

